const easeQuartInOut = [0.76, 0, 0.24, 1];
export const tranitionDomReady = { ease: easeQuartInOut, duration: 0.4, delay: 0.15 };
export const getDefferedTransition = (order, thumbnail = false) => {
    const deferredTransition = Object.assign({}, tranitionDomReady);
    if (thumbnail) {
        deferredTransition.duration = 0.5;
        deferredTransition.delay = 0.1 * order;
    }
    else {
        deferredTransition.delay = 0.25 + 0.1 * order;
    }
    return deferredTransition;
};
